<template>
<div>
	<div v-if="status === this.$cons.STATUS.LOADING" class="text-center"
		style="margin-top: 25px">
		<strong> <i class="fa fa-refresh fa-spin" />
			{{$t('misc.waitLoading')}}
		</strong>
	</div>

	<div v-else-if="status === this.$cons.STATUS.ERROR"
		class="alert alert-danger fade in" style="margin-top: 25px">
		<!--     <span v-html="$t('misc.errorDataLoading')"></span><br> -->
		<!--     <span v-if="this.$store.error == 1">{{$t('misc.errorServerResponse', {status: this.$store.status})}}</span> -->
		<!--     <span v-else>{{$t('misc.errorNoServerResponse')}}</span> -->
		<strong><i class="glyphicon glyphicon-warning-sign" /> 
			<span v-if="msg">{{msg}}</span>
			<span v-else>Ein Fehler ist aufgetreten, Daten konnten nicht geladen werden</span>
		</strong>
	</div>

</div>
</template>

<script>
export default {
  name: "ServerStatus",
  props: ["status", "msg"],
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/globals/ServerStatus.vue